import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { UpdateNoteService } from '../../services/update-note.service';
import { UpdateNoteCardComponent } from '../update-note-card/update-note-card.component';

/**
 * "What's new" popup, shown once per session when notes were published since the user last
 * dismissed it. Mounted globally in MenuComponent and driven entirely by UpdateNoteService.
 */
@Component({
  selector: 'app-update-notes-modal',
  imports: [
    RouterLink,
    DialogModule,
    ButtonModule,
    TranslocoModule,
    UpdateNoteCardComponent,
  ],
  templateUrl: './update-notes-modal.component.html',
})
export class UpdateNotesModalComponent {
  private updateNoteService = inject(UpdateNoteService);

  visible = this.updateNoteService.modalVisible;
  notes = this.updateNoteService.unseen;

  private isAcknowledging = false;

  /** Covers the close button, the X, Escape and the mask. */
  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.acknowledge();
    }
  }

  close(): void {
    this.acknowledge();
  }

  private acknowledge(): void {
    if (this.isAcknowledging) {
      return;
    }
    this.isAcknowledging = true;

    this.updateNoteService.markSeen().subscribe({
      next: () => {
        this.isAcknowledging = false;
      },
      error: (error) => {
        console.error('Failed to acknowledge update notes:', error);
        // Close anyway: the popup will simply come back next session.
        this.updateNoteService.closeModal();
        this.isAcknowledging = false;
      },
    });
  }
}
